import $ from 'jquery';

import { AddressesForm } from './AddressesForm';

export class EditAddressForm extends AddressesForm {
  constructor(container) {
    super(container);
  }
}
